import React, { useState, useEffect } from 'react';
import HeaderPage from './HeaderPage';
import FooterPage from './FooterPage';

const FullLayout = ({ children }) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Sticky Header */}
      <div
        className={`fixed top-0 left-0 w-full duration-[600ms] z-[15] bg-white ${
          isSticky ? 'shadow-sm' : ''
        }`}>
        <HeaderPage />
      </div>

      {/* Main Content */}
      <main className="flex-1 pt-[60px] relative">{children}</main>

      {/* Footer */}
      <FooterPage />
    </div>
  );
};

export default FullLayout;
